import { createContext } from 'react';
import { IKpiChartOverlay } from '@report-content';

export interface KpiChartOverlaysContextType {
    onUpdate: (id: string, changes: Partial<IKpiChartOverlay>) => void;
    onDelete: (id: string) => void;
}

export const KpiChartOverlaysContext = createContext<KpiChartOverlaysContextType | null>(null);
